"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverTierDisplay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var services_1 = require("@falcon/services");
var React = require("react");
var commonFunctions_1 = require("../helpers/commonFunctions");
var Tree_1 = require("./Tree");
var CoverTierDisplay = /** @class */ (function (_super) {
    __extends(CoverTierDisplay, _super);
    function CoverTierDisplay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    CoverTierDisplay.prototype.render = function () {
        if (this.props.product === services_1.ProductsEnum.HOME) {
            return (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Home cover tier: ", this.getHomeCoverTier(this.props.tier)] }) });
        }
        else if (this.props.product === services_1.ProductsEnum.WOLF_MOTOR) {
            return (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Motor cover tier: ", (0, commonFunctions_1.getCoverTierWording)(this.props.tier)] }) });
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    CoverTierDisplay.prototype.getHomeCoverTier = function (coverTierEnumName) {
        switch (coverTierEnumName) {
            case services_1.HomeCoverTier.BRONZE: {
                return services_1.resourcesHelper.PRODUCT_TIER_1;
            }
            case services_1.HomeCoverTier.SILVER: {
                return services_1.resourcesHelper.PRODUCT_TIER_2;
            }
            case services_1.HomeCoverTier.GOLD: {
                return services_1.resourcesHelper.PRODUCT_TIER_3;
            }
            default: {
                return "";
            }
        }
    };
    return CoverTierDisplay;
}(React.Component));
exports.CoverTierDisplay = CoverTierDisplay;
//# sourceMappingURL=CoverTierDisplay.js.map